__turbopack_context__.v({
  "ingress__container": "Inngress-module-scss-module__Z11PNa__ingress__container",
  "intro": "Inngress-module-scss-module__Z11PNa__intro",
  "links": "Inngress-module-scss-module__Z11PNa__links",
});
